import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const cancelarEmisionesPendientes = async (body) => {
    try {
        const response = await mainAxios.post(
            `/v1/emision/cancelar/stream`,
            body,
            getDefaultHeaders()
        );

        return response;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};

export const cancelarEmisionesSSE = async (fecha, onMessage, signal) => {
    try {
        const baseURL = process.env.VUE_APP_API_URL;
        const url = `${baseURL}v1/emision/cancelar/stream-sse?fecha=${encodeURIComponent(fecha)}`;

        const response = await fetch(url, {
            method: 'GET',
            signal: signal,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("agenteAccessToken")}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok)
            throw new Error(`HTTP error! status: ${response.status}`);

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let reading = true;

        while (reading) {
            const { done, value } = await reader.read();
            if (done) {
                if (buffer.trim().startsWith('data:')) {
                    const jsonStr = buffer.replace('data:', '').trim();
                    try {
                        const data = JSON.parse(jsonStr);
                        onMessage(data);
                    } catch (e) {
                        console.error('Error parsing final buffer:', e);
                    }
                }
                reading = false;
                break;
            }

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n');
            buffer = lines.pop() || '';

            for (const line of lines) {
                if (line.startsWith('data:')) {
                    try {
                        const jsonStr = line.replace('data:', '').trim();
                        const data = JSON.parse(jsonStr);
                        onMessage(data);
                    } catch (e) {
                        console.error('Error parsing JSON:', e);
                    }
                }
            }
        }
        return { success: true };
    } catch (error) {
        if (error.name === 'AbortError') {
            return { success: false, aborted: true };
        }
        throw new Error(getErrorMessage(error));
    }
};

export const detenerCancelacionProceso = async (procesoId) => {
    try {
        const baseURL = process.env.VUE_APP_API_URL;
        const response = await fetch(`${baseURL}v1/emision/cancelar/stop?procesoId=${procesoId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("agenteAccessToken")}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};

export const obtenerFechasCancelaciones = async () => {
    try {
        const response = await mainAxios.get(
            `/v1/emision/fechas/cancelaciones`,
            getDefaultHeaders()
        );

        return response;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};

export const obtenerCancelaciones = async (body) => {
    try {
        const response = await mainAxios.post(
            `/v1/emision/cancelaciones`, body,
            getDefaultHeaders()
        );

        return response;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};